import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 账号类型
 */
class Type extends UltMeta {
    ENTERPRISE = new Meta(1, "对公账户");
    PERSONAL = new Meta(2, "个人账户");
}
export const TYPE = new Type();
